<template>
  <div class="bloc d-flex justify-space-around px-2 pb-3">
    <action-btn
      v-show="usenfc"
      name="toNfc"
      class="btn-action-small"
      :icon="IconEnum.scan_nfc"
      @click="$emit('to-nfc')"
    />
    <action-btn
      v-show="useqrcodes"
      name="toQrcode"
      class="btn-action-small"
      :icon="IconEnum.scan_qrcode"
      @click="$emit('to-qr-scanner')"
    />
    <action-btn
      v-show="usemanscan"
      name="toKeyboard"
      class="btn-action-small"
      :icon="IconEnum.scan_keyboard"
      @click="$emit('to-keyboard')"
    />
    <action-btn
      v-show="useCustomer"
      name="toCustomer"
      class="btn-action-small"
      :image="require('@/assets/img/address-book.svg')"
      @click="$emit('to-customer')"
    />
  </div>
</template>

<script>
import { IconEnum, ActionEnum } from '@/modules/Enums'

export default {
  name: 'ScanChoice',

  props: {
    action: { type: Number, default: null },
    route: { type: String, default: null }
  },

  data () {
    return {
      IconEnum
    }
  },

  computed: {
    useCustomer () { return this.action === ActionEnum.loyalty },
    usenfc () { return this.$store.state.usenfc && !this.route.includes('nfc') },
    useqrcodes () { return this.$store.state.useqrcodes && !this.route.includes('qrcode') },
    usemanscan () { return this.$store.state.usemanscan }
  }
}
</script>
